export enum PpapCapability {
	No = 0,
	Yes = 10,
	RequireHelp = 20,
}
